<ng-template #loading>
    <app-mat-spinner-overlay text="Vent litt..."></app-mat-spinner-overlay>
</ng-template>

<div *ngIf="data; else loading" class="flex-column flex-gap-20">

    <h1>{{getLabelValue('Title') | striphtml}}</h1>

    <div class="helpbox" [innerHTML]="getLabelValue('ElKomContent') | safe: 'html'"></div>

    <div class="flex-row flex-gap-20">

        <div class="button-container">
            <button mat-raised-button color="primary" (click)="navigateBack()">
                <span class="button-label">
                    <mat-icon>arrow_circle_left</mat-icon>
                    <span class="btn-label left">{{getLabelValue('ButtonGoBack') | striphtml}}</span>
                </span>
            </button>
        </div>

        <div class="button-container">
            <button (click)="login()" mat-raised-button color="primary" class="reverse"
                [matTooltip]="getLabelValue('ButtonElkomDescription') | striphtml">
                <span [innerHTML]="getLabelValue('ButtonElkom') | striphtml"></span>
                <mat-icon fontSet="material-icons-outlined">arrow_circle_right</mat-icon>
            </button>
            <p class="text-description" [innerHTML]="getLabelValue('ButtonElkomDescription') | safe: 'html'"></p>
        </div>

        <!-- <div class="button-container">
            <button (click)="navigate('/form/' + complaintType + '/' + attemptResolved + '/' + attemptSettlement)" mat-raised-button color="primary" class="reverse" [matTooltip]="getLabelValue('ButtonNoElkomDescription') | striphtml">
                <span [innerHTML]="getLabelValue('ButtonNoElkom') | striphtml"></span>
                <mat-icon fontSet="material-icons-outlined">arrow_circle_right</mat-icon>
            </button>
            <p class="text-description" [innerHTML]="getLabelValue('ButtonNoElkomDescription') | safe: 'html'"></p>
        </div> -->
    </div>

</div>